import type { FC } from "preact/compat";
import { CloseIcon } from "@icons/close-icon";
import classnames from "classnames";
import "./index.scss";

export type MultiSelectListOptionProps = {
  value: string;
  label: string;
  selected?: boolean;
  handleSelectOption?: (
    item: { value: string; label: string },
    checked: boolean,
  ) => void;
};

export const MultiSelectListOption: FC<MultiSelectListOptionProps> = ({
  handleSelectOption,
  value,
  label,
  selected,
}) => {
  const handleChange = () => {
    handleSelectOption?.(
      {
        value,
        label,
      },
      !selected,
    );
  };
  const handleClick = () => {
    handleSelectOption?.(
      {
        value,
        label,
      },
      !selected,
    );
  };
  return (
    <li
      className="cursor-pointer rounded hover:bg-gt-slate-light hover:bg-opacity-20"
      role="option"
      aria-selected={selected ? "true" : "false"}
    >
      <p className="font-normal text-medium flex items-center px-4 h-12 ml-0">
        <input
          className="mx-2 my-1 text-lg fas accent-gt-lilactext-lg cursor-pointer"
          type="checkbox"
          name={value}
          checked={selected}
          aria-hidden="true"
          onChange={handleChange}
        />
        <span onClick={handleClick} className="flex w-full h-full items-center gap-4">{label}</span>
      </p>
    </li>
  );
};

export type SingleSelectListOptionProps = {
  value: string;
  label: string;
  selected?: boolean;
  handleClose?: () => void;
  handleSelectOption?: (
    item: { value: string; label: string },
    checked: boolean,
  ) => void;
};

export const SingleSelectListOption: FC<SingleSelectListOptionProps> = ({
  handleSelectOption,
  handleClose,
  value,
  label,
  selected,
}) => {
  const handleClick = () => {
    handleSelectOption?.(
      {
        value,
        label,
      },
      !selected,
    );
    handleClose?.();
  };
  return (
    <li
      className={`combobox-list-option cursor-pointer z-50 rounded ${
        selected ? "bg-gt-lilac-light" : "bg-transparent"
      } hover:bg-gt-slate-light hover:bg-opacity-20`}
      role="option"
      aria-selected={selected ? "true" : "false"}
      onClick={handleClick}
    >
      <p className="combobox-list-option__text font-normal text-medium flex items-center ml-0">
        <span className="flex items-center gap-4">{label}</span>
        <span
          className={classnames("combobox-list-option__close", {
            "combobox-list-option__close--selected": selected,
          })}
        ><CloseIcon /></span>
      </p>
    </li>
  );
};
